import axios from "axios";

export async function getTrainer() {
    return await axios
        .get(`${process.env.REACT_APP_API_URL}getTrainer.php`)
        .then((res) => res.data)
        .catch((err) => {
            console.log(err);
            return {
                datas: [],
                album: []
            };
        });
}
